export const cRailLengths = [10, 15, 20, 25, 30, 35, 45, 65, 85, 105, 125, 145, 165, 185, 205, 225, 245, 265, 285, 305]
